export const PRODUCTS_PER_BRAND = 4;

export type PopularBrandConfig = { slug: string; name: string };

export type PopularBrandsLocationKey = 'us' | 'uk' | 'au';

export const POPULAR_BRANDS_COUNT = 3;

/** Shared pool; currently used for all locations. Replace US/UK/AU lists below to diverge per country. */
const DEFAULT_POOL: PopularBrandConfig[] = [
  { slug: 'adidas', name: 'Adidas' },
  { slug: 'aritzia', name: 'Aritzia' },
  { slug: 'converse', name: 'Converse' },
  { slug: 'free-people', name: 'Free People' },
  { slug: 'jcrew', name: 'J.Crew' },
  { slug: 'levi-s', name: `Levi's` },
  { slug: 'madewell', name: 'Madewell' },
  { slug: 'nike', name: 'Nike' },
  { slug: 'the-north-face', name: 'The North Face' },
  { slug: 'patagonia', name: 'Patagonia' },
  { slug: 'ralph-lauren', name: 'Ralph Lauren' },
  { slug: 'steve-madden', name: 'Steve Madden' },
];

/** Popular brands for US (and CA). */
const US_BRANDS: PopularBrandConfig[] = [...DEFAULT_POOL];

/** Popular brands for UK (and DE, IE, IT, FR). */
const UK_BRANDS: PopularBrandConfig[] = [...DEFAULT_POOL];

/** Popular brands for AU (and NZ). */
const AU_BRANDS: PopularBrandConfig[] = [...DEFAULT_POOL];

export const BRANDS_BY_LOCATION_KEY: Record<
  PopularBrandsLocationKey,
  PopularBrandConfig[]
> = {
  us: US_BRANDS,
  uk: UK_BRANDS,
  au: AU_BRANDS,
};

/** Maps locale to brand list key (CA→US, DE/IE/IT/FR→UK, NZ→AU). Default 'us' for unknown. */
export const LOCATION_TO_KEY: Record<string, PopularBrandsLocationKey> = {
  us: 'us',
  ca: 'us',
  uk: 'uk',
  de: 'uk',
  ie: 'uk',
  it: 'uk',
  fr: 'uk',
  au: 'au',
  nz: 'au',
};
